/* eslint-disable linebreak-style */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';
import Box from 'base-ui/dist/Box';
import Lists from 'base-ui/dist/Lists';

const SummaryBox = ({ summary, permalink }) => {
  const [summaryActive, setSummaryActive] = useState(1);

  return (
    <Box className="menu-nav">
      <Lists>
        {summary.map((item) => (
          <li key={item.id}>
            <Link
              smooth
              to={`${permalink}#${item.id}`}
              aria-label={item.title}
              className={`${item.id === summaryActive ? 'is-active' : ''}`}
              scroll={() => {
                setSummaryActive(item.id);
                document.getElementById(item.id).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                setTimeout(() => {
                  document.getElementById(item.id).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                }, 1500);
              }}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </Lists>
    </Box>
  );
};

SummaryBox.propTypes = {
  summary: PropTypes.array,
  permalink: PropTypes.string
};

SummaryBox.defaultProps = {
  summary: [],
  permalink: ''
};

export default SummaryBox;
